


























































































































































import {
    Component,
    Prop,
    Vue,
    Provide,
    Inject
} from "vue-property-decorator";
import utils from '@/utils/utils'
@Component({
    components: {}
})
export default class TopicInfo extends Vue {
    @Prop(Object) data: any
    @Prop(Boolean) more_than_30
    @Inject('is_notice')
    is_notice

    topic_images = []
    topic_images_show=[]
    mounted() {
        // this.topic_images = 
        this.get_img_srcs(this.data._images)
    }

    get get_style() {
        let style: any = {}
        if (this.data.deep === 0) {
            // style['font-weight'] = 600
            style['color'] = '#000'
        } else {
            style['border-left'] = '1px solid #b3d8ff '
        }
        style['margin-left'] = `${6*this.data.deep}px`
        return style
    }

    get get_post_time() {
        return utils.simple_time(this.data.post_time)
    }

    get get_username_style() {
        let style: any = {}
        if (this.data.type === 1) {
            style.color = 'rgb(121, 187, 255)'
        } else if (this.data.type === 2) {
            style.color = ' rgb(102,177,255 )'
        } else if (this.data.type === 3) {
            style.color = ' rgb(83,168, 255)'
        } else if (this.data.type === 4 || this.data.type === 5) {
            style.color = '#409EFF'
        } else if (this.data.type >= 10) {
            style.color = '#0077b7'
        }
        return style
    }

    get_img_src(src) {
        if (src.startsWith('http') || src.startsWith('data:image'))
            return src
        else {
            return `https://club.isso.com.cn${src}`
        }
    }
    get_img_srcs(images) {
        if (images == undefined) {
            return []
        }
        let res = []
        for (let image of images) {
            let img = ''
            if (image.startsWith('http') || image.startsWith('data:image'))
                img =image
            else {
                img = `https://club.isso.com.cn${image}`
            }
            this.topic_images.push(img)
            if (this.topic_images_show.length<4)
                this.topic_images_show.push(img)
        }
        // return res
    }
    get get_face(){
        if (this.data.face===''){
            return ''
        }
        // if(this.data.face.startsWith('Face/')){
        //     return `https://club.isso.com.cn/${this.data.face}`
        // }else
        return `https://club.isso.com.cn/${this.data.face}`
    }
    open_topic(){
        window.open(`https://club.isso.com.cn/Default.aspx?class=Topic&Topic=${this.data.topic_id}&Pink=False`)
    }

    do_show_owner_topic(){
        this.$emit('only_show_owner')
    }
}
